module.exports = __webpack_public_path__ + "img/PrepaidCode_Website.3b516d3c.jpg";